export const TOP_UP_ACTION = 'top-up-action' as const;
export const TOP_UP_DRAWDOWN_ACTION = 'top-up-drawdown-action' as const;

export type DashboardActionTypes =
    typeof TOP_UP_ACTION | typeof TOP_UP_DRAWDOWN_ACTION | null;
